// extracted by mini-css-extract-plugin
module.exports = {"base":"SkillSection_base__zSeMF","heading":"SkillSection_heading__N_PUs","body":"SkillSection_body__O8Ik3","skillItem":"SkillSection_skillItem__5_ZlL"};